import { createTheme, responsiveFontSizes } from "@material-ui/core/styles"

let theme = createTheme({
  typography: {
    fontFamily: "Nunito",
    fontWeightBold: 600,
    fontWeightBolder: 700,

    h1: {
      fontSize: "4rem", // 64px
      fontWeight: 400
    },
    h2: {
      fontSize: "3.50rem", // 48px
      fontWeight: 400
    },
    h3: {
      fontSize: "3rem", // 48px
      fontWeight: 400
    },
    h4: {
      fontSize: "2.25rem", // 36px
      fontWeight: 400
    },
    h5: {
      fontSize: "1.5rem", // 24px
      fontWeight: 400
    },
    h6: {
      fontSize: "1.25rem", // 20px
      fontWeight: 400
    },
    body1: {
      fontSize: "1rem" // 16px
    },
    body2: {
      fontSize: "0.75rem" // 12px
    }
  },
  palette: {
    primary: {
      main: "#315EFB"
    },
    success: {
      main: "#28BC00"
    },
    grey: {
      carbon: "#343B4C",
      pearlGrey: "#C6CAD8",
      aluminium: "#EEF2F4"
    },
    darkBlue: "#274BC8"
  },
  gradients: {
    blueLightBlue:
      "linear-gradient(117deg, rgba(58,47,203,1) 0%, rgba(43,154,183,1) 100%)",
    primaryButton: "linear-gradient(to right, #315EFB , #41B3FF)",
    bluePurple: "linear-gradient(113deg, #7B16FF 0%, #384CD5 97%)",
    yellowRed:
      "linear-gradient(90deg, rgba(255,227,110,1) 0%, rgba(253,29,29,1) 100%)",
    bluePink:
      "linear-gradient(117deg, rgba(81,120,255,1) 0%, rgba(255,75,231,1) 100%)"
  }
})

// Toolbar responsiveness settings
theme.mixins.toolbar = {
  minHeight: 56,
  [`${theme.breakpoints.up("xs")} and (orientation: landscape)`]: {
    minHeight: 48
  },
  [theme.breakpoints.up("sm")]: {
    minHeight: 64
  }
}

// Settings custom shadow on paper (default: elevation-1)
theme.shadows[1] = "2px 3px 6px rgba(0, 0, 0, 0.13)"

// Primary gradient button shadow
// TODO: Change this shadow and make enroll button into its own component
theme.shadows[25] = "1px 3px 4px rgba(49, 94, 251, 0.4)"

// Adjust font sizes based on the viewport width
theme = responsiveFontSizes(theme)

export default theme
